import React from "react";

const ContactCommunicationsHelp = () => (
  <div>
    <p>
      Use this dashboard to triage legacy questions and support requests that were submitted before the public portal Contact function was retired.
    </p>

    <h3>Purpose</h3>
    <p>
      Provide NWAC Administrators and Regional Managers with a consolidated view of existing contact messages,
      including the applicant context and a quick way to update status as triage progresses.
    </p>

    <h3>Key workflows</h3>
    <ul>
      <li>Review the queue of new messages and switch status as replies are drafted or completed.</li>
      <li>Track response progress and resolution outcomes to ensure applicants receive timely support.</li>
      <li>Capture recurring inquiries so knowledge base and portal copy can be updated.</li>
    </ul>

    <h3>Data sources</h3>
    <ul>
      <li>
        Records reside in the <code>contact_message</code> table. The public portal&apos;s <code>/api/contact</code>
        endpoint now rejects new submissions because secure Messages is the applicant support path.
      </li>
      <li>
        Staff updates sync back to the admin API, emitting <code>contact_message.updated</code> events for audit and notifications.
      </li>
    </ul>

    <h3>Next steps toward production</h3>
    <ul>
      <li>Hook widgets into live data services and enforce RBAC for message actions.</li>
      <li>Connect acknowledgement templates once the auto-reply decision in CR-0005 is finalised.</li>
      <li>Capture analytics on response time to support future SLA reporting.</li>
    </ul>
  </div>
);

ContactCommunicationsHelp.aiContext =
  "Describe the Contact Communications dashboard that surfaces legacy contact_message records, shows queue status, and helps NWAC Administrators and scoped Regional Managers triage applicant enquiries submitted before the public portal Contact function was retired.";

export default ContactCommunicationsHelp;
